import { api } from '../lib/api-client';

/**
 * The branch's stock locations, for every screen that takes or counts stock.
 * Shared here, not in a feature, because the workshop, parts and POS screens
 * all pick one and features never import each other (CLAUDE.md §4).
 */
export interface StockLocation {
  uid: string;
  code: string;
  name: string;
  /** The branch's main location, which every picker starts on (Q98). The server lists it first. */
  isMain: boolean;
}

export const STOCK_LOCATIONS_KEY = ['stock-locations'] as const;

export function listStockLocations(): Promise<StockLocation[]> {
  return api<StockLocation[]>('/parts/locations');
}

export function makeMainLocation(uid: string): Promise<StockLocation[]> {
  return api<StockLocation[]>(`/parts/locations/${uid}/transitions/make-main`, { method: 'POST' });
}
